import { createFileRoute, Link, notFound } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { Section, SectionHeader } from "@/components/Section";
import { CTASection } from "@/components/CTASection";
import { SITE } from "@/lib/site";
import { seoTitle, seoDescription } from "@/lib/seo-meta";
import { listServices } from "@/lib/services.functions";

const TITLE = seoTitle("Serviços — Dedetizadora em Chapecó");
const DESC = seoDescription("Todos os serviços de controle de pragas oferecidos em Chapecó e região: dedetização, controle de roedores, escorpião, cupim, baratas e atendimento 24h.");

const servicesQuery = { queryKey: ["services-active"], queryFn: () => listServices(), staleTime: 300_000 };

export const Route = createFileRoute("/servicos/")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: "/servicos" },
    ],
    links: [{ rel: "canonical", href: `${SITE.baseUrl}/servicos` }],
  }),
  loader: ({ context }) => context.queryClient.ensureQueryData(servicesQuery),
  component: ServicesIndex,
  errorComponent: ({ error }) => <div className="container-svg py-20 text-center">Erro: {String(error)}</div>,
  notFoundComponent: () => { throw notFound(); },
});

function ServicesIndex() {
  const { data } = useSuspenseQuery(servicesQuery);
  return (
    <>
      <Section>
        <SectionHeader eyebrow="o que fazemos" title="Nossos serviços" description="Controle de pragas para residências, empresas, condomínios, restaurantes, mercados, indústrias e comércios em Chapecó e região." />
        <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {data.map((s) => (
            <Link key={s.slug} to="/servicos/$slug" params={{ slug: s.slug }} className="card-glass group block h-full overflow-hidden p-0">
              {s.cover_image ? (
                <div className="relative h-48 w-full overflow-hidden">
                  <img src={s.cover_image} alt={s.label} loading="lazy" width={600} height={400} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/0 to-transparent" />
                </div>
              ) : null}
              <div className="p-5">
                <h3 className="text-lg font-semibold group-hover:text-primary transition-colors">{s.label}</h3>
                <p className="mt-2 text-sm text-muted-foreground line-clamp-3">{s.description}</p>
                <span className="mt-4 inline-block text-xs font-semibold uppercase tracking-wide text-primary">ver detalhes →</span>
              </div>
            </Link>
          ))}
        </div>
      </Section>
      <CTASection title="Precisa de um serviço agora?" text="Fale conosco pelo WhatsApp e receba um orçamento gratuito." buttonLabel="Falar no WhatsApp" />
    </>
  );
}
